import axios, { AxiosResponse } from 'axios';
import { ILeiCheckResp } from 'types/leiTypes';

const checkLeiApi = (lei: string) => {
    return axios({
        method: 'GET',
        url: 'LEI/CheckLEI',
        params: {
            lei: lei
        }
    }).then((resp: AxiosResponse<ILeiCheckResp>) => resp.data);
};

export default checkLeiApi;
